<template>
  <div class="container" @click="closeMask">
    <div class="nav">
      <div class="logo-container" @click="backHome">
        <img src="@/assets/mobile/122322.png" alt="Logo" class="logo-image" />
        <span style="font-size: 12px !important; white-space: nowrap">{{config.appName}}</span>
      </div>
      <div class="user-dropdown">
        <div class="user-header" @click.stop="toggleDropdown">
          <div
            class="user-name"
            style="
              font-family: Source Han Serif SC, Source Han Serif SC;
              max-width: 100px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              font-size: 12px;
            "
          >
            {{ name }}
          </div>
          <i class="dropdown-icon" v-if="getUserType" :class="{ rotate: isDropdownOpen }"></i>
        </div>
        <div class="dropdown-menu" :class="{ show: isDropdownOpen }">
          <div class="usage-info">
            <div class="usage-item">
              <i class="model-dot basic"></i>
              <span>残り解析回数</span>
              <b>{{ quota }}回</b>
            </div>
          </div>
          <div class="menu-actions">
            <button class="action-btn profile" @click="goToUserProfile">
              分析ログ
            </button>
            <button class="action-btn recharge" @click="goSubscription">
              定期でお得
            </button>
            <button class="action-btn purple" @click="goToInviteRewards" v-if="showAgent">
                紹介報酬
              </button>
            <button class="action-btn logout" @click="logout">ログアウト</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { logout, getUserInfo } from "@/api/index";
export default {
  components: {},
  props: {
    sessionid: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentTime: new Date().toLocaleString(),
      currentStep: "agreement", // 'agreement', 'home', 'analysis'
      agreementChecked: false,
      agreementScrolled: false,
      showLoginSuccess: false,
      isDropdownOpen: false,
      name: localStorage.getItem("userName") || "ログイン/登録",
      r1AiQuota: 0,
      v3AiQuota: 0,
      quota: 0,
      getUserType:false,
      // 分析页面
      analysisType: "",
      showAgent:false,
      config:{

      }
    };
  },
  async created() {
    // 读取配置文件
    const response = await fetch("/config.json");
    this.config = await response.json();
    console.log(this.config, "config");
    // 修改名称
    // this.config.appName = '2222'

    // 如果需要保存回文件，需要后端支持
  },
  computed: {},
  mounted() {
    if (localStorage.getItem("ACCESS_TOKEN") != undefined) {
      this.getUser();
      this.getUserType = true;
    }
    // alert(this.$route.query.auth + this.$route.query.userName)
    if (this.$route.query.auth) {
      localStorage.setItem("ACCESS_TOKEN", this.$route.query.auth);
      this.getUser();
      this.getUserType = true;
    }
    // 每分钟
  },
  methods: {
    backHome() {
      this.$router.push("/mobile_home");
    },
    closeMask(event) {
      // 只有当点击事件不是来自dropdown区域时才关闭下拉菜单
      if (event && !event.target.closest('.user-dropdown')) {
        this.isDropdownOpen = false;
      }
    },
    getUser() {
      getUserInfo().then((res) => {
        console.log(res, "res");
        this.quota = res.data.quota;
        if (res.data.phone != null) {
          this.name = res.data.phone;
          localStorage.setItem("userName", res.data.phone);
        }
        if (res.data.email != null) {
          this.name = res.data.email;
          localStorage.setItem("userName", res.data.email);
        }
        if(res.data.agentId != null){
          this.showAgent = true
        }
      });
    },
    logout() {
      logout().then((res) => {
        this.name = 'ログイン/登録'
        this.isDropdownOpen = !this.isDropdownOpen;
        this.getUserType = false
        // localStorage.removeItem("ACCESS_TOKEN");
        // localStorage.removeItem("userName");
        // localStorage.removeItem("agreementStatus");
        // localStorage.removeItem("inviteCode")
        localStorage.clear()
        this.$router.push("/mobile_home");
        // window.location.reload();
      });
    },
    toggleDropdown() {
        console.log("toggleDropdown");
      if (localStorage.getItem("ACCESS_TOKEN") == undefined) {
        this.$router.push("/mobile_login");
        return;
      }else{
        this.getUser();
      }
      this.isDropdownOpen = !this.isDropdownOpen;
    },

    goToUserProfile() {
      this.$router.push("/analysis-records");
      this.isDropdownOpen = false; // 关闭下拉菜单
    },

    goSubscription() {
      if (this.sessionId != "") {
        localStorage.setItem("sessionId", this.sessionId);
      }
      if (localStorage.getItem("ACCESS_TOKEN") == undefined) {
        this.$router.push("/mobile_login");
        return;
      }
      // 跳转到订阅活动页面
      this.$router.push("/subscription");
    },
    goToInviteRewards() {
      // 跳转到邀请返现页面
      this.$router.push("/invite-rewards");
      this.isDropdownOpen = false;
    },
    goToFeedback() {
      // 跳转到意见反馈页面
      this.$router.push("/feedback");
    },

    updateTime() {
      this.currentTime = new Date()
        .toLocaleString("zh-CN", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        })
        .replace(/\//g, "-");
    },
    goToAnalysis(type) {
      this.analysisType = type;
      // 直接跳转到对应的分析页面，不再需要传递用户信息
      // 直接跳转到八字分析页面，不存储生辰信息
      this.$router.push({
        path: "/ai-analysis",
      });
    },
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  /* height: 100%; */
  width: 100%;
  position: relative;
  background: #0e1313;
  /* overflow: hidden; */
  background-image: url("../../../assets/mobile/dateBack.png");
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  z-index: 1;
}

.logo-container {
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
}

.logo-image {
  height: 32px;
  width: 32px;
  animation: rotate 30s linear infinite;
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* font-family: kunpeng; */
  font-weight: 400;
  font-size: 16px;
  color: #caa87c;
  padding: 0 20px;
  text-align: right;
  height: 56px;
}

.user-dropdown {
  position: relative;
  cursor: pointer;
}
.user-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dropdown-icon {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid rgba(255, 255, 255, 0.6);
  margin-left: 6px;
  transition: transform 0.3s ease;
}

.dropdown-icon.rotate {
  transform: rotate(180deg);
}

.dropdown-menu {
  display: none;
}

.dropdown-menu.show {
  display: block;
}
.dropdown-menu {
  position: absolute;
  top: calc(100% + 5px);
  right: 0;
  width: 240px;
  background: #000000d9;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(222, 184, 135, 0.2);
  border-radius: 8px;
  padding: 16px;
  opacity: 0;
  transform: translateY(-10px);
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 9999;
}
.show {
  opacity: 1;
  transform: translateY(0);
  visibility: visible;
}
.successMask {
  width: 90%;
  background: #0e1313;
  border-radius: 2px;
  margin: 30% auto auto auto;
  text-align: center;
  padding: 40px 0 40px 0;
  display: flex;
  flex-direction: column;
  position: relative;
}

.successMask-btn {
  background: #473f35;
  padding: 9px 55px;
  margin: 10% auto;
  color: #caa87c;
  font-size: 15px;
  width: 165px;
  height: 40px;
  white-space: nowrap;
}
.usage-info {
  padding-bottom: 13px;
  border-bottom: 1px solid rgba(222, 184, 135, 0.1);
  margin-bottom: 16px;
}
.usage-item {
  display: flex;
  align-items: center;
  gap: 8px;
  /* padding: 8px 0; */
  color: #fffc;
  font-size: 14px;
  font-family: Source Han Serif SC-Regular;
}
.usage-item b {
  margin-left: auto;
  color: #deb887e6;
}
.menu-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.action-btn {
  width: 100%;
  padding: 9px;
  border-radius: 6px;
  font-size: 14px;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.profile {
  background: #93c5fd33;
  color: #93c5fde6;
  border: 1px solid rgba(147, 197, 253, 0.3);
}
.recharge {
  background: #deb88733;
  color: #deb887e6;
  border: 1px solid rgba(222, 184, 135, 0.3);
}
.active {
  background: #a78bfa33;
  color: #a78bfae6;
  border: 1px solid rgba(167, 139, 250, 0.3);
}
.logout {
  background: #ff63471a;
  color: #ff6347e6;
  border: 1px solid rgba(255, 99, 71, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 36px;
}
.action-btn:hover,
.action-btn.active {
  background-color: rgba(202, 168, 124, 0.4);
}
.purple {
  background: #a78bfa33;
  color: #a78bfae6;
  border: 1px solid rgba(167, 139, 250, 0.3);
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

</style>
